export const blockIconsContentClear = (
	<span className='material-symbols-outlined'>clear</span>
);
